import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const VolumeIcon = ({
  color = RoutalPalette.grey1,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14.17 17.39" style={{ width: `16px`, height: `16px`, color, ...props.style }}>
      <g>
        <path d="M7.08,17.3s-.06,0-.09,0c-3.82-.05-6.85-3.08-6.9-6.9H.09C.09,7.14,2.32,3.27,5.76.55c.78-.62,1.87-.62,2.65,0,3.44,2.73,5.66,6.59,5.66,9.84-.05,3.83-3.17,6.91-6.99,6.91ZM1.09,10.39c.04,3.27,2.64,5.87,5.91,5.91,3.27.06,6.02-2.61,6.06-5.91,0-2.9-2.12-6.55-5.29-9.05-.41-.33-.99-.33-1.41,0C3.22,3.84,1.1,7.47,1.09,10.39ZM6.62,13.21c-1.55,0-2.82-1.26-2.82-2.82,0-.28.22-.5.5-.5s.5.22.5.5c0,1,.82,1.82,1.82,1.82.28,0,.5.22.5.5s-.22.5-.5.5Z" />
      </g>
    </SvgIcon>
  );
};
